import React from 'react'
import PropTypes from 'prop-types'
import * as Component from './ResultsHeader.styles'
import { TextContext } from 'hocs/TextContextProvider/TextContextProvider'

import { Icon } from 'components/atoms'

const ResultsHeader = (props) => {
  const { onOpenAllClicked, hideControls, openAll } = props
  const textContext = React.useContext(TextContext)

  return (
    <>
      {!hideControls && (
        <Component.Root
          className={ `${ openAll ? 'openAll' : '' }` }
          onClick={ () => onOpenAllClicked() }
          data-cy='resultTile-open-all'>
          <>
            <Icon className={ `icon-f-arrow-down` } />
            <Component.Link>
              {openAll
                ? textContext['resultsHeader.openAll']
                : textContext['resultsHeader.closeAll']}
            </Component.Link>
          </>
        </Component.Root>
      )}
    </>
  )
}

ResultsHeader.defaultProps = {
  hideControls: false,
}

ResultsHeader.propTypes = {
  /* click handler */
  onOpenAllClicked: PropTypes.func.isRequired,
  /* toggle visibility of component */
  hideControls: PropTypes.bool,
  /* open/closed state of result tiles */
  openAll: PropTypes.bool,
}

export default ResultsHeader
